export default {
  common: {
    answer: '答え',
    send: '送信',
    selectNumberOfPointsToSend: '送るポイント数を選択',
    informationForExtensionFile: '添付ファイルの拡張子に関する情報',
    viewVideo: 'ビデオを見る',
    file: 'ファイル',
    close: '閉じる',
    sendPoint: 'ポイントを送る',
    download: 'をダウンロードする',
    downloadFile: '[{filename}]をダウンロードする',
    comment: 'コメント',
    coin: 'コイン',
    point: '枚',
    countSuffix: '枚',
    login: 'ログインする',
    unsolved: '回答受付中',
    resolved: '解決済み',
    male: '男性',
    female: '女性',
    all: 'すべて ',
    congratulation: 'おめでとうございます！',
    receivedPointFromCompany: '会社から {n} ポイントが贈られました',
    receivedCreditFromCompany: '会社から {n} クレジットが贈られました',
    note: '注意',
    message: 'メッセージ',
    warning_maintenance_title: 'システムメンテナンスを行っています',
    warning_maintenance1:
      '現在システムメンテナンスを行っているため、Cheeersをご利用いただくことはできません。',
    warning_maintenance2: 'ご不便をおかけしますが、ご理解いただきますようお願いいたします。',
    warning_maintenance_footer: '詳細につきましてはお問い合わせよりご連絡ください。',
    system_notify: '管理人からのお知らせ',
  },
  time: {
    day: '日付',
    minute: '分',
    second: '秒',
    hours: '0 hour | an hour | {count} hours',
    days: '0 day | a day | {count} days',
    months: '0 month | a month | {count} months',
    weeks: '0 week | a week | {count} weeks',
    years: '0 year | a year | {count} years',
    nHours: '0時間 | 1時間 | {count}時間',
    nMinutes: '0分 | 1分 | {count}分',
    nSeconds: '0秒 | 1秒 | {count}秒',
    inToday: '今日まで',
    untilTomorrow: '明日まで',
    inDays: '0日以内 | 1日以内 | {count}日以内',
    inWeeks: '0週間以内 | 1週間以内 | {count}週間以内',
    inMonths: '0ヶ月以内 | 1ヶ月以内 | {count}ヶ月以内',
  },
  calendar: {
    formatMonthDay: 'M月D日(ddd)',
  },
  lang: {
    ja: '日本語',
    en: 'English',
    vi: 'Tiếng Việt',
  },
  menu: {
    home: 'HOME',
    issue: '質問箱',
    myIssue: '質問箱',
    message: '感謝コメント',
    exchange: 'ベネフィット',
    eLearning: '学習する',
    bulletinBoard: '掲示板',
    profile: 'プロフィール',
  },
  issue: {
    myQuestionBox: 'My 質問箱',
    supporting: 'サポート中',
    unResolved: '未解決',
    solved: '解決済',
    resolveBySelf: '自己解決',
    changeToResolved: '解決済みに変更する',
    whoHelpToResolve: 'この投稿の解決者',
    shareHowToSolveProblem: 'どうやって解決したかをみんなに共有しよう！',
    noOneHelpToResolve: '自分解決のため解決者はいません',
    resolve: 'この内容で決定する',
    choose: 'お礼をいう',
    choosePoint: '協力者へのポイント選択',
    selected: '選択済み',
    addReaction: 'リアクションを送る',
    body: {
      solved: '解決しました !',
    },
    download: '[{filename}]をダウンロードする',
  },
  navbar: {
    attendanceManagement: '勤怠管理',
    working: {
      start: '勤務開始',
      startBreak: '休憩開始',
      finishBreak: '休憩終了',
      stop: '帰宅',
      dailyReport: '日報',
    },
    setting: '各種設定',
    logout: 'ログアウト',
    workingTime: '労働時間',
    attendanceTable: '勤怠表',
  },
  sidebar: {
    cheeersCoin: 'Cheeersコイン',
    exchangeForGoods: '商品と交換',
    remainPoint: '残りのポイント',
    expireTime: 'ポイント消滅まで',
    coinRaking: 'コインランキング',
    sendGift: 'ポイントを送る',
    receivedThanksRanking: '感謝コメント獲得数ランキング',
    sendThanksRanking: '感謝コメント通信数ランキング',
    byMonth: '月ごと',
  },
  login: {
    noteSarafi: '※ Cookieの設定を有効にしてください',
    email: 'メールアドレス',
    password: 'パスワード',
    forgotPassword: 'パスワードを忘れた方はこちら',
    rememberUsername: 'ログイン状態を保持する',
    language: '言語選択',
  },
  validation: {
    wrongCredential: 'Wrong username or password',
    alpha: '{_field_}はアルファベットのみ使用できます',
    alpha_num: '{_field_}は英数字のみ使用できます',
    alpha_dash: '{_field_}は英数字とハイフン、アンダースコアのみ使用できます',
    alpha_spaces: '{_field_}はアルファベットと空白のみ使用できます',
    between: '{_field_}は{min}から{max}の間でなければなりません',
    confirmed: '{_field_}が一致しません',
    digits: '{_field_}は{length}桁の数字でなければなりません',
    dimensions: '{_field_}は幅{width}px、高さ{height}px以内でなければなりません',
    email: '{_field_}は有効なメールアドレスではありません',
    excluded: '{_field_}は不正な値です',
    ext: '{_field_}は有効なファイル形式ではありません',
    image: '{_field_}は有効な画像形式ではありません',
    integer: '{_field_}は整数のみ使用できます',
    is: '{_field_}が一致しません',
    is_not: '{_field_}は無効です ',
    length: '{_field_}は{length}文字でなければなりません',
    max_value: '{_field_}は{max}以下でなければなりません',
    max: '{_field_}は{length}文字以内にしてください',
    mimes: '{_field_}は有効なファイル形式ではありません',
    min_value: '{_field_}は{min}以上でなければなりません',
    min: '{_field_}は{length}文字以上でなければなりません',
    numeric: '{_field_}は数字のみ使用できます',
    oneOf: '{_field_}は有効な値ではありません',
    regex: '{_field_}のフォーマットが正しくありません',
    required: '{_field_}は必須項目です',
    required_if: '{_field_}は必須項目です',
    size: '{_field_}は{size}KB以内でなければなりません',
    double: '{_field_}フィールドは有効な10進数である必要があります',
    strong_password: '{_field_} 小文字、大文字、数字の両方を含める必要があります',
    max_size_file: 'ファイル は {max_size}MB 以内でなければなりません',
  },
  home: {
    listQuestion: 'みんなの質問一覧',
    myQuestionBox: '質問箱',
    supported: 'サポート中',
    unResolved: '未解決',
    solved: '解決済',
    selfSolved: '自己解決',
    all: 'すべて',
    sort: '並び替え',
    btnPostQuestion: '質問を投稿する',
    issueItem: {
      header: {
        postIssueCreated: '投稿日時',
        btnUnresolved: '未解決',
        btnResolved: '解決済',
        supporting: 'サポート中',
        coinEarn: '獲得できるコイン',
        endRecruitment: '終了まで',
      },
      contentRight: {
        btnTalk: 'トークする',
        btnApplied: '申請済み',
        now: '現在',
        peopleAppling: '名がトーク中',
        earnCoin: 'さんがコイン獲得 ',
      },
      contentLeft: {
        btnResolved: '解決しました！',
      },
      comments: {
        talkTo: '{name} とトーク',
      },
    },
    dialogPostQuestion: {
      post: '質問を投稿する',
      type: '質問のカテゴリーを選択',
      title: '質問のタイトルを入力',
      content: '質問の内容',
      expiredTime: 'いつまでに解決したい？',
      timeLine: '期限',
      submit: 'この質問を投稿する',
    },
  },
  profile: {
    title: 'プロフィール設定',
    avatarTitle: '写真',
    informationTitle: '登録',
    maxFileSizeWarning: 'ファイル最大サイズ: {size}',
    button: {
      uploadAvatar: '写真を登録する',
      submit: 'この内容で登録',
    },
    field: {
      avatar: '写真は自動的に<br>丸トリミングされます',
      name: '名前',
      email: 'メールアドレス',
      birthday: '誕生日',
      gender: '性別',
      status: 'コメント',
    },
    cumulative: '累計',
    coinsReceived: '受取コイン',
    numTimesReceived: '受取回数',
    yearOfService: '勤続年数',
  },
  setting: {
    title: '各種設定',
    languageSetting: '言語選択',
    notificationSetting: '通知設定',
    receivePostNotification: '新規投稿通知',
    receiveThanksNotification: '感謝コメント通知',
    receiveTalkNotification: 'トーク通知',
    pointSetting: 'ポイント設定',
    pointSettingNote1: '*５種類の値を設定できます',
    pointSettingNote2: '*いつでも設定を変更できます',
    passwordSetting: 'パスワード変更',
    newPassword: '新パスワード',
    newPasswordConfirm: '新パスワード(確認用)',
    updated: '正常に更新',
  },
  thanks: {
    title: 'すべての感謝コメント',
    addThanks: '感謝コメントを送る',
    earnCoin: '獲得コイン',
    showMore: 'もっと見る',
    showLess: '少ない見る',
    filter: {
      all: 'すべてのメッセージ',
      forYou: 'あなたへ',
      fromMe: 'あなたから',
    },
  },
  addThanks: {
    title: '感謝コメントを送る',
    filter: {
      branch: '事業部',
      group: 'チーム',
      search: '名前で検索',
    },
    button: {
      thank: '感謝コメントを送る',
      submit: '感謝コメントを送る',
    },
    selectPoint: '送るポイントを選択',
    message: 'この感謝コメントを送る',
    category: '感謝のメッセージを贈ろう',
    sendAThankMessageTo: '{name} に感謝メッセージを送る！',
  },
  exchange: {
    title: 'Benefit',
    sidebar: {
      title: 'コインを交換',
    },
    content: {
      title: 'アイテム一覧',
      viewDetail: '詳しく見る',
    },
    itemDetail: {
      title: 'アイテムの詳細',
      exchangeForProduct: 'コインと交換する',
      dontHaveProductInStock: '商品の在庫がありません',
      dontHaveEnoughCoin: 'コインが足りない',
    },
    history: {
      title: '交換履歴',
    },
    purchaseCompleted: {
      title: '購入完了しました',
      thanks: 'アイテムの購入ありがとうございます！',
      receivingMethodBelow: '以下のアイテム受け取り方法をご確認下さい。',
      methodReceive: '受け取り方法',
      doneStock: 'オフィスの保管場所からお取りください',
      close: '閉じる',
      instructionReceiveProduct: '交換商品の受け取りの案内 :',
    },
  },
  systemNotification: {
    receivedPoint: {
      title: 'おめでとうございます！',
      given: 'さんから',
      forYou: '獲得しました！',
      exchange: 'コメントを確認する',
    },
    popUp: {
      confirm: 'このページを離れますか？入力したコメントは保存されません。',
    }
  },
  working: {
    actions: {
      checkin: {
        success: 'おはようございます。今日も良い1日を！',
        fail: 'コールセンターにご連絡ください。',
        title: '勤務を開始しますか？',
      },
      checkout: {
        success: '今日も1日おつかれさまでした！',
        fail: 'コールセンターにご連絡ください。',
        title: '勤務を終了しますか？',
      },
      pause: {
        success: 'リフレッシュしてくださいね！',
        fail: 'コールセンターにご連絡ください。',
        title: '休憩しますか？',
      },
      continue: {
        success: 'おかえりなさい！',
        fail: 'コールセンターにご連絡ください。',
        title: '勤務を再開しますか？',
      },
    },
  },
  bulletin: {
    create: {
      titleHeader: '掲示板',
      title: '掲示板のタイトル',
      contentTitle: 'みんなにシェアしたいことを書き込もう！',
      imageTitle: '写真を追加',
      attachFile: 'ファイルを追加',
      submit: '投稿する',
      contentPlaceholder: 'こに内容を入力してください',
      chooseImage: '画像を選択',
      chooseAttachment: '添付ファイルを選択',
      txtFieldTitleName: '掲示板',
      txtFieldContentName: '掲示板の内容',
    },
  },
  eLearning: {
    date: '日付',
    sendSuccess: '成功を送る',
    allCategory: '@:common.all',
    learningProgress: '閲覧率',
    correctAnswer: 'スコア',
    answerProgress: '進捗状況に答える',
    numberOfCorrectAnswer: '正解数',
    notAttended: '未受講',
    question: '問',
    nQuestions: '0問 | 1問 | {n}問 ',
    learn: '教材を見る',
    viewTestResult: 'テスト結果を見る',
    doTheTest: 'テストを受ける',
    startTheTest: 'テストを開始する',
    pageNumber: 'ページ数',
    nPages: '0ページ | 1ページ | {n}ページ',
    limitTime: '所要時間',
    testResult: 'テストの結果',
    questionNoN: '設問{n}',
    numberOfQuestion: '設問数',
    testQuestionNote: '※各設問の回答には制限時間があります',
    remainTimeToAnswer: '回答の残り時間',
    nextQuestion: '次の設問へ',
  },
  attendance: {
    title: '勤怠管理',
    checkAttendanceTable: '勤怠表の確認',
    checkDailyAttendance: '日ごとの勤怠を確認',
    stamp: '打刻する',
    checkinTime: '出勤時間',
    checkoutTime: '退勤時間',
    startBreak: '休憩問始時間',
    endBreak: '休憩終了時間',
    workingHours: '労働時間',
    overtimeHours: '残業時間',
    dailyReport: '日報',
  },
  dailyReport: {
    title: '今日のレポートを送る',
    comment: '今日のコメントを入力してください',
    attachment: '添付ファイル',
    chooseFileAttachment: '添付ファイルを選択',
    selectIcons: 'アイコンを選択',
    submit: 'レポートを投稿する',
  },
  editComment: {
    title: 'コメントを直す',
    submit: '更新',
    delete: '削除',
    message: '内容',
    txtFieldCommentName: '解決方法',
  },
  surveyQuestion: {
    number: '質問 {0}',
    dialog: {
      content1: 'チアーズチェック',
      content2: '社内エンゲージ調査にご協力ください',
      start: 'はじめる',
    },
  },
  mission: {
    notice: 'ミッションクリアまであと {times}回',
    letClearMission: 'チームみんなでミッションをクリアしよう！',
    deadline: '期限',
    clear: 'ミッションクリア！',
    title: 'ミッション',
    currentEarnedTrophy: '現在の獲得トロフィー',
    finish: 'ミッションを達成しよう！！',
    missionOfMonth: '今月のミッション {0}年{1}月{2}日 ~ {3}年{4}月{5}日',
    startMission: 'ミッション開始！気合入れていこう',
    fiftyPercent: '{times}件突破！折り返し地点です！！',
    clearMission: 'ミッションを達成！おめでとうございます！',
    item: {
      content: 'みんなで今月の<span class="font-weight-bold">{content}</span>を目指そう！',
    },
    popUp: {
      text1: 'ミッション {number}',
      text2: '達成!!',
    },
    trophyVision: '目的意識',
    trophyRelationships: '人間関係',
    trophyContribute: '貢献意欲',
    trophyGrowth: '成長意欲',
    trophyAttendance: '勤怠管理',
  },
  sloganAnswer: {
    question: '会社の{slogan}は？',
    correctAnswer: 'すばらしい！正解です！',
    errorMessage: '惜しい、正解は「{correctAnswer}」です。もう一度チャレンジしませんか？',
    yes: '決定',
    cancel: 'キャンセル',
  },
};
